import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { ArrowRight, Sparkles } from 'lucide-react';
import { Button } from '@/components/ui/button';
import ConexusSymbol from '@/components/logos/ConexusSymbol';
import { trackBooking } from '@/utils/analytics';

const CTASection = () => {
  const { t, i18n } = useTranslation();

  return (
    <section className="py-24 bg-accent relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-10 left-10 w-48 h-48">
          <Sparkles className="w-full h-full text-primary" />
        </div>
        <div className="absolute bottom-10 right-10 w-64 h-64">
          <Sparkles className="w-full h-full text-primary" />
        </div>
      </div>

      {/* Glowing Background */}
      <div className="hidden md:block absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-primary/10 rounded-full blur-3xl" />

      <div className="container mx-auto px-4 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="max-w-3xl mx-auto text-center"
        >
          {/* Symbol */}
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="mb-8 flex justify-center"
          >
            <ConexusSymbol className="h-16 w-16" />
          </motion.div>

          {/* Headline */}
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-accent-foreground mb-6">
            {t('cta.ready')}
          </h2>

          {/* Subtitle */}
          <p className="text-lg text-accent-foreground/90 mb-10 max-w-xl mx-auto">
            {t('cta.readySubtitle')}
          </p>

          {/* Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              asChild
              size="lg"
              className="bg-primary text-primary-foreground hover:bg-primary/90 shadow-glow text-lg px-8"
            >
              <a
                href={
                  i18n.language === 'en'
                    ? 'https://calendly.com/d/cxsd-r9h-zc4/academic-strategy-consultation-english'
                    : 'https://calendly.com/d/cxsd-rm9-hsx/consulta-para-estrategia-academica-portuguese'
                }
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => trackBooking()}
              >
                {t('cta.bookConsultation')}
                <ArrowRight className="ml-2 h-5 w-5" />
              </a>
            </Button>
            <Button
              asChild
              variant="outline"
              size="lg"
              className="border-white/50 text-white hover:bg-white/10 bg-white/10 text-lg px-8"
            >
              <Link to="/programs">{t('cta.explorePrograms')}</Link>
            </Button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTASection;
